<template>
  <div>
    <electricity-meter/>
  </div>
</template>

<script>
import ElectricityMeter from "@/components/device_details/ElectricityMeter";

export default {
  name: "DeviceDetail",
  components: {ElectricityMeter}
}
</script>

<style scoped>

</style>